<div>
  Hello{{ profile && profile.givenName ? ", " + profile.givenName : "" }}
</div>
